import React from 'react'
import styles from './report.module.css'

export default function LastMoves({ translate }) {
    return (
        <div className={styles.cards}>
            <p style={{marginBottom: '27px'}} className={styles.bigTitle}>{translate('last_moves')}</p>
            <div className={styles.oneCard} >
                <div className='d-flex items-center justify-between' >
                    <span className={styles.id} >#12345678</span>
                    <div className={styles.type} >Typeeee</div>
                </div>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <div className={` ${styles.div} d-flex items-center`}>
                    <span className={styles.subTitle} style={{ width: "20%" }} >{translate('amount')}: </span>
                    <span className={styles.num} >5204746520</span>
                </div>
                <div className='d-flex items-center'>
                    <span className={styles.subTitle} style={{ width: "20%" }}>{translate('total')}:</span>
                    <span className={styles.num} >5204746520</span>
                </div>
            </div>
            <div className={styles.oneCard} >
                <div className='d-flex items-center justify-between' >
                    <span className={styles.id} >#12345678</span>
                    <div className={styles.type} >Typeeee</div>
                </div>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <div className={` ${styles.div} d-flex items-center`}>
                    <span className={styles.subTitle} style={{ width: "20%" }} >{translate('amount')}: </span>
                    <span className={styles.num} >5204746520</span>
                </div>
                <div className='d-flex items-center'>
                    <span className={styles.subTitle} style={{ width: "20%" }}>{translate('total')}:</span>
                    <span className={styles.num} >5204746520</span>
                </div>
            </div>
            <div className={styles.oneCard} >
                <div className='d-flex items-center justify-between' >
                    <span className={styles.id} >#12345678</span>
                    <div className={styles.type} >Typeeee</div>
                </div>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <div className={` ${styles.div} d-flex items-center`}>
                    <span className={styles.subTitle} style={{ width: "20%" }} >{translate('amount')}: </span>
                    <span className={styles.num} >5204746520</span>
                </div>
                <div className='d-flex items-center'>
                    <span className={styles.subTitle} style={{ width: "20%" }}>{translate('total')}:</span>
                    <span className={styles.num} >5204746520</span>
                </div>
            </div>
        </div>
    )
}
